import "../assets/index-018895f7.css";
import { n as e } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const n = {
  name: "NcActionSeparator"
};
var r = function() {
  var a = this, t = a._self._c;
  return t("li", { staticClass: "action action-separator action--disabled", attrs: { role: "separator" } });
}, o = [], s = /* @__PURE__ */ e(
  n,
  r,
  o,
  !1,
  null,
  "82b7f2ae",
  null,
  null
);
const l = s.exports;
export {
  l as default
};
